import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BrandLogoFallbackDirective } from '../directives/brand-logo-fallback.directive';
import { DEFAULT_FALLBACK_COLOR, DEFAULT_FONT_SIZE, FallbackColor } from '../utils/svg.util';

@Component({
  selector: 'lib-brand',
  templateUrl: './brand.component.html',
  styleUrls: ['./brand.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BrandLogoFallbackDirective],
})
export class BrandComponent {
  readonly url = input<string>();
  readonly backgroundImage = input<string>();
  readonly maxWidth = input<number>(120);
  readonly ariaLabel = input<string>();
  readonly brandName = input<string>('');
  readonly fallbackColor = input<FallbackColor>(DEFAULT_FALLBACK_COLOR);
  readonly fallbackFontSize = input<number>(DEFAULT_FONT_SIZE);
}
